import { ICashFlowPeriod, IProFormaReturnsData } from 'views/ProFormaTable/types';

/* eslint-disable no-unused-vars */
export enum AggregateReportProperties {
    TOTAL_DEVELOPMENT_COST = 'Total development cost',
    TOTAL_INTEREST = 'Total interest',
    TOTAL_FINANCING_FEES = 'Total financing fees',
    TOTAL_LOAN_DRAWS_DURING_DEVELOPMENT = 'Total loan draws during development',
    PERMANENT_LOAN_FUNDING = 'Permanent loan funding',
    CASH_FLOW_FROM_OPERATIONS = 'Cash flow from operations',
    PERMANENT_LOAN_DEBT_SERVICE = 'Permanent loan debt service',
    NET_SALE_PROCEEDS = 'Net sale proceeds',
    CONSTRUCTION_LOAN_PAYOFF = 'Construction loan payoff',
    PERMANENT_LOAN_PAYOFF = 'Permanent loan payoff',
    EQUITY_PROCEEDS_FROM_CAPITAL_EVENTS = 'Equity proceeds from capital event(s)',
    NET_UNLEVERED_CASH_FLOW = 'Net unlevered cash flow',
    NET_LEVERED_CASH_FLOW = 'Net levered cash flow',
    YIELD_ON_COST = 'Yield-on-cost',
    MARKET_CAPITALIZATION_RATE = 'Market cap rate',
    DEVELOPMENT_SPREAD = 'Development spread',
}

export const PropertyKeyToLabelMap = {
    totalProjectCost: AggregateReportProperties.TOTAL_DEVELOPMENT_COST,
    totalLoanInterest: AggregateReportProperties.TOTAL_INTEREST,
    totalFinancingFees: AggregateReportProperties.TOTAL_FINANCING_FEES,
    totalConstructionLoanDraws: AggregateReportProperties.TOTAL_LOAN_DRAWS_DURING_DEVELOPMENT,
    totalPermanentLoanFunding: AggregateReportProperties.PERMANENT_LOAN_FUNDING,
    totalCashFlowFromOperations: AggregateReportProperties.CASH_FLOW_FROM_OPERATIONS,
    totalPermanentLoanDebtService: AggregateReportProperties.PERMANENT_LOAN_DEBT_SERVICE,
    totalNetSaleProceeds: AggregateReportProperties.NET_SALE_PROCEEDS,
    totalConstructionLoanPayoff: AggregateReportProperties.CONSTRUCTION_LOAN_PAYOFF,
    totalPermanentLoanPayoff: AggregateReportProperties.PERMANENT_LOAN_PAYOFF,
    totalEquityProceedFromCapitalEvents: AggregateReportProperties.EQUITY_PROCEEDS_FROM_CAPITAL_EVENTS,
    netUnleveredCashFlow: AggregateReportProperties.NET_UNLEVERED_CASH_FLOW,
    netLeveredCashFlow: AggregateReportProperties.NET_LEVERED_CASH_FLOW,
};

export const PRO_FORMA_RETURN_TOOLTIPS: Partial<Record<AggregateReportProperties, string>> = {
    [AggregateReportProperties.TOTAL_DEVELOPMENT_COST]: 'Before interest reserve and financing fees',
    [AggregateReportProperties.TOTAL_INTEREST]: 'Before lease-up income',
};

export const CostMetricKeyToLabelMap = {
    yieldOnCost: AggregateReportProperties.YIELD_ON_COST,
    marketCapRate: AggregateReportProperties.MARKET_CAPITALIZATION_RATE,
    developmentSpread: AggregateReportProperties.DEVELOPMENT_SPREAD,
};

export const spacerRows = [
    AggregateReportProperties.TOTAL_FINANCING_FEES,
    AggregateReportProperties.PERMANENT_LOAN_FUNDING,
    AggregateReportProperties.PERMANENT_LOAN_DEBT_SERVICE,
];

export enum Periods {
    MONTHLY = 'Monthly',
    QUARTERLY = 'Quarterly',
    ANNUALLY = 'Annually',
}

export const PERIOD_OPTIONS = [
    { label: Periods.MONTHLY, value: Periods.MONTHLY },
    { label: Periods.QUARTERLY, value: Periods.QUARTERLY },
    { label: Periods.ANNUALLY, value: Periods.ANNUALLY },
];

export const proFormaReturnsDataKeys: Array<
Exclude<keyof IProFormaReturnsData, 'cashFlow' | 'yearlyCashFlow' | 'yieldOnCost' | 'developmentSpread' | 'marketCapitalizationRate'>
> = [
    'totalProjectCost',
    'totalLoanInterest',
    'totalFinancingFees',
    'totalConstructionLoanDraws',
    'totalPermanentLoanFunding',
    'totalCashFlowFromOperations',
    'totalPermanentLoanDebtService',
    'totalNetSaleProceeds',
    'totalConstructionLoanPayoff',
    'totalPermanentLoanPayoff',
    'totalEquityProceedFromCapitalEvents',
];
export const proFormaReturnsCashFlowDataKeys: Array<
Exclude<keyof ICashFlowPeriod, 'developmentUsesPeriodTotals'>
> = [
    'projectCost',
    'loanInterest',
    'financingFee',
    'constructionLoanDraws',
    'permanentLoanFunding',
    'cashFlowFromOperations',
    'permanentLoanDebtService',
    'netSaleProceeds',
    'constructionLoanPayoff',
    'permanentLoanPayoff',
    'equityProceedFromCapitalEvents',
];
